
export default {
	mounted() {
		
	},
}
